import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CartContext } from "./CartContext"; // adjust path if needed

import bannerimage from "../image/product-newme15-coupon.webp";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import aboutimg from "../image/dharajbanner.jpg";
import axios from "axios";
import BaseUrl from './Baseurl/Api.js';
import Slider from "react-slick";
 import Productdetailmain from "./Productdetailmain.js"

const Productdetails = () => {
  const { id } = useParams();
  const [productDetails, setProductDetails] = useState([]);
  const [productValue, setProductValue] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [countNum, setCountNum] = useState(1);
  const selectedProduct = productValue.find(inv => inv.id === selectedVariant);

  const [orderproduct, setOrderProduct] = useState(null);
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);

  const { addToCart } = useContext(CartContext);



  // main image state
  const [mainImage, setMainImage] = useState("");

  // Fetch product details
  useEffect(() => {
  BaseUrl.get("/api/get_allproduct") // Only the path; Axios uses baseURL
    .then((res) => {
      if (res.data.status === "success") {
        setProductDetails(res.data.product);

        const product = res.data.product.find((p) => id.includes(p.id.toString()));
        if (product) {
            setMainImage(
              `https://dharajwebbackend.concentics.com/productimage/${product.productImage}`
            );
          }
      }
    })
    .catch((err) => console.error("Error fetching product data:", err));
}, [id]);

  // Fetch inventory details
  useEffect(() => {
  BaseUrl.get("/api/get_inventory")
    .then((res) => {
      if (res.data.status === "success") {
        setProductValue(res.data.inventory);
      }
    })
    .catch((err) => console.error("Error fetching inventory data:", err));
}, []);

  const handleVariantClick = (variantId) => {
    setSelectedVariant(variantId);
    setOrderProduct(variantId);

    const clickedInv = productValue.find((inv) => inv.id === variantId);
    if (clickedInv) {
      setMainImage(
        `https://dharajwebbackend.concentics.com/productimage/${clickedInv.image}`
      );
    }
  };

  // Quantity functions
  const addQuantity = () => {
    if (selectedProduct && countNum < selectedProduct.inventory) {
      setCountNum((prev) => prev + 1);
    } else {
      alert("Maximum available stock reached.");
    }
  };

  const subQuantity = () => {
    if (countNum > 1) {
      setCountNum((prev) => prev - 1);
    }
  };

  //device Id
  const [deviceId, setDeviceId] = useState("");

  useEffect(() => {
    const getOrGenerateDeviceId = () => {
      let storedDeviceId = localStorage.getItem("deviceId");

      if (!storedDeviceId) {
        storedDeviceId = `${Math.random().toString(36).substr(2, 9)}`; // Generate a random ID
        localStorage.setItem("deviceId", storedDeviceId);
      }

      setDeviceId(storedDeviceId);
    };

    getOrGenerateDeviceId();
  }, []);

  // Add to cart function
  const handleAddToCart = async () => {
    const selectedProduct = productValue.find(
      (inv) => inv.id === selectedVariant
    );
    if (!selectedProduct || countNum <= 0) {
      alert("Please select a variant and enter valid quantity.");
      return;
    }

    const diviceIddata = localStorage.getItem("deviceId");
    const userid = localStorage.getItem("Id");

    const cartData = {
      cartImage: selectedProduct.image,
      cartproductname: selectedProduct.productName,
      cartprice: selectedProduct.totalamount,
      proquantity: selectedProduct.productmeasurement,
      qtycategory: selectedProduct.producttype,
      totalamount: selectedProduct.totalamount * countNum,
      discount: selectedProduct.discount,
      quantity: countNum,
      pid: selectedProduct.pid,
      diviceId: diviceIddata,
      uid: userid,
    };

    try {
      await fetch("https://dharajwebbackend.concentics.com/api/get_cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });

      alert("Product added to cart!");
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const handleBuyNow = async () => {
    const selectedProduct = productValue.find(
      (inv) => inv.id === selectedVariant
    );
    if (!selectedProduct || countNum <= 0) {
      alert("Please select a variant and enter valid quantity.");
      return;
    }

    const diviceIddata = localStorage.getItem("deviceId");
    const userid = localStorage.getItem("userId");

    const productdetails = {
      pid: selectedProduct.pid,
      actualprice: selectedProduct.totalamount * countNum,
      qty: countNum,
      divid: diviceIddata,
      cid: userid,
      status: "BuyNow",
      price: selectedProduct.totalamount,
      promeasurement: selectedProduct.productmeasurement,
      procategory: selectedProduct.producttype,
    };

    try {
      await fetch("https://dharajwebbackend.concentics.com/api/get_orderproduct", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(productdetails),
      });

      alert("Redirecting to checkout...");
      navigate("/CheckOut/BuyNow");
    } catch (error) {
      console.error("Error during buy now:", error);
    }
  };


  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    // Fetch API data
    axios
      .get(`https://dharajwebbackend.concentics.com/api/related_product/${id}`)
      .then((res) => {
        if (res.data.status && res.data.data) {
          setRelatedProducts(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching related products:", err);
      });
  }, [id]);

  return (
    <>
    <style>
      {` .product-section {
          background: var(--bg-light);
          padding: var(--space-lg) 0;
        }
        .section-title {
          text-align: center;
          font-weight: 700;
          font-size: var(--font-xl);
          margin-bottom: var(--space-xs);
          color: var(--color-text);
        }
        .section-sub {
          text-align: center;
          color: var(--color-muted);
          margin-bottom: var(--space-md);
        }
        .card-wrap {
          padding: var(--space-sm);
          box-sizing: border-box;
        }
        .t4s-product {
          background: var(--bg-light);
          border-radius: 0 var(--border-radius-card) var(--border-radius-card) 0;
          overflow: hidden;
          position: relative;
          padding: var(--padding-card);
          box-shadow: var(--box-shadow-card);
          transition: transform .2s ease, box-shadow .2s ease;
        }
        .t4s-product:hover {
          transform: translateY(-6px);
          box-shadow: var(--box-shadow-hover);
        }
        .t4s-product-img {
          width: 100%;
          aspect-ratio: 1/1;
          position: relative;
          overflow: hidden;
          border-radius: var(--radius-sm);
          background: var(--color-accent);
        }
        .t4s-product-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity .2s ease;
        }
        .t4s-product-hover-img {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          opacity: 0;
        }
        .t4s-product-img:hover .t4s-product-hover-img {
          opacity: 1;
        }
        .badge-left {
          position: absolute;
          top: 12px; left: 12px;
          background: var(----color-ternary);
          color:  var(--color-text);
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          font-weight: 700;
          font-size: var(--font-xs);
        }
        .discount-wedge {
          position: absolute;
          top: 12px; right: 12px;
          background: #ff6b6b;
          color: var(--color-secondary);
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          font-weight: 700;
          font-size: var(--font-xs);
        }
        /* --- hover action bar --- */
      .t4s-atc-bar {
  display: flex;
  gap: var(--space-sm);
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity .2s ease, transform .2s ease;
}

.t4s-product:hover .t4s-atc-bar {
  opacity: 1;
  transform: translateY(0);
}

/* Make links behave like flex children */
.t4s-atc-bar a {
  flex: 1;
  display: flex;
}

.atc-btn, .buy-btn {
  flex: 1; /* ensures equal width */
  height: 40px;
  border-radius: var(--border-radius-btn);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: 0;
  cursor: pointer;
}

        .atc-btn {
          background: var(--color-primary);
          color: var(--color-secondary);
        }
        .atc-btn:hover {
          background: var(--bg-main);
        }
        .buy-btn {
          background:  var(--color-ternary);
          color: var(--color-secondary);
        }
        .buy-btn:hover {
          background: #e68900;
        }
        .t4s-product-info {
          margin-top: var(--space-sm);
          text-align: center;
        }
        .t4s-product-title {
          font-weight: 700;
          font-size: var(--font-sm);
          color: var(--color-text);
          margin: var(--space-xs) 0;
        }
        .t4s-product-price {
          margin-top: var(--space-xs);
        }
        .t4s-product-price del {
          color: var(--color-muted);
          margin-right: 8px;
          text-decoration: line-through;
        }
        .t4s-product-price ins {
          color: var(--color-primary);
          font-weight: 800;
          text-decoration: none;
        }
        .rating-row {
          margin-top: var(--space-xs);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--space-xs);
        }
        .stars {
          color:  var(--color-ternary);
          font-size: var(--font-sm);
        }
        .rev-count {
          color: var(--color-muted);
          font-size: var(--font-xs);
        }
         .pd-buttons {
      display: flex;
      gap: 10px;
      margin-top: 20px;
      flex-wrap: wrap;
    }

    .pd-buttons button {
      border: none;
      border-radius: 999px;
      padding: 10px 22px;
      font-weight: 700;
      font-size: 14px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      letter-spacing: 0.5px;
    }

    .btn-cart {
      background-color: #28a745;
      color: white;
      box-shadow: 0 4px 10px rgba(40, 167, 69, 0.2);
    }

    .btn-cart:hover {
      background-color: #218838;
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(40, 167, 69, 0.3);
    }

    .btn-buy {
      background-color: --color-muted;
      color: white;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }

    .btn-buy:hover {
      background-color:--color-dark-ternary;
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.4);
    }

   

    @media (max-width: 576px) {
      .pd-buttons {
        flex-direction: column;
      }

      .pd-buttons button {
        width: 100%;
        justify-content: center;
      }
    }
    `}
    </style>
  
      <style>{`
    .related-product-img img {
      width: 273px;
      height: 273px;
    }
  `}</style>

  <Productdetailmain/>
   
    <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
  <div className="container">
    <div className="row mb-4">
      <div className="col-12" style={{ borderRight: "3px solid red" }}>
        <h2 className="mb-4 fs-1 fw-bold">Related Products</h2>
      </div>
    </div>

    {relatedProducts.length > 0 ? (
      <Slider
        dots={false}
        infinite={relatedProducts.length > 4}
        speed={400}
        slidesToShow={4}
        slidesToScroll={1}
        autoplay={true}
        autoplaySpeed={2500}
        responsive={[
          { breakpoint: 1280, settings: { slidesToShow: 3 } },
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 600, settings: { slidesToShow: 2 } },
          { breakpoint: 450, settings: { slidesToShow: 1 } },
        ]}
      >
        {relatedProducts.map((prod) => {
          const inv = productValue.find((inv) => inv.pid.toString() === prod.id.toString());
          const compareP = inv?.compare_price ?? inv?.mrp ?? null;
          const priceP = inv?.price ?? inv?.selling_price ?? null;

          let discountPercent = null;
          if (compareP && priceP && Number(compareP) > Number(priceP)) {
            discountPercent = Math.round(((compareP - priceP) / compareP) * 100);
          }

          const mainImg = prod.productImage?.startsWith("http")
            ? prod.productImage
            : `https://dharajwebbackend.concentics.com/productimage/${prod.productImage}`;

          const hoverImg = prod.image2
            ? prod.image2.startsWith("http")
              ? prod.image2
              : `https://dharajwebbackend.concentics.com/productimage/${prod.image2}`
            : mainImg;

          return (
            <div className="card-wrap p-2" key={prod.id}>
              <div
                className="t4s-product"
                onMouseEnter={() => setHovered(prod.id)}
                onMouseLeave={() => setHovered(null)}
              >
                {prod.isBestseller && <div className="badge-left">Bestseller</div>}
                {discountPercent && <div className="discount-wedge">-{discountPercent}%</div>}

                <div className="t4s-product-img">
                  <img
                    alt={prod.productName}
                    src={mainImg}
                    style={{ opacity: hovered === prod.id ? 0 : 1 }}
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/600x600?text=No+Image")
                    }
                  />
                  <img
                    alt={`${prod.productName} hover`}
                    className="t4s-product-hover-img"
                    src={hoverImg}
                    onError={(e) => (e.target.src = mainImg)}
                  />
                  <div className="t4s-atc-bar">
                    <Link to={`/productdetails/${prod.id}`} style={{ textDecoration: "none" }}>
                      <button
  className="atc-btn"
  onClick={() => {
    addToCart(1);  
    alert("Product added to cart!");
  }}
>
  ADD TO CART
</button>

                    </Link>
                    <Link to={`/productdetails/${prod.id}`} style={{ textDecoration: "none" }}>
                      <button className="buy-btn">BUY NOW</button>
                    </Link>
                  </div>
                </div>

                <div className="t4s-product-info">
                  <h3 className="t4s-product-title">
                    <Link
                      to={`/productdetails/${prod.id}`}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {prod.productName}
                    </Link>
                  </h3>
                  <div className="t4s-product-price">
                    {compareP && <del>₹{Number(compareP).toFixed(2)}</del>}
                    <ins>{priceP ? `₹${Number(priceP).toFixed(2)}` : "Price Not Available"}</ins>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    ) : (
      <div className="col-12 text-center mt-4">
        <p className="text-muted">No related products found.</p>
      </div>
    )}
  </div>
</section>


    </>

  );
};

export default Productdetails;